import { propEq } from 'ramda';
import branch from '../branch';
import renderComponent from '../render-component';

export default TrueComponent =>
  branch(propEq('condition', true), renderComponent(TrueComponent));
